import type { Comment } from "@/lib/humhub-api/types";

type OptimisticComment = {
  _optimistic?: boolean;
  isSending?: boolean;
};

export const getEffectiveIsSending = (comment?: Comment, isSending?: boolean) =>
  Boolean(
    isSending ||
    (comment as OptimisticComment | undefined)?.isSending ||
    (comment as OptimisticComment | undefined)?._optimistic,
  );

export const getIsAnyActionLoading = ({
  isDeleting,
  isSubmittingEdit,
  isSending,
}: {
  isDeleting?: boolean;
  isSubmittingEdit?: boolean;
  isSending?: boolean;
}) => Boolean(isDeleting || isSubmittingEdit || isSending);
